import styles from "./ConfirmProgramOptOutDialog.module.scss";
import ConfirmOptOutDialog from "../ConfirmOptOutDialog.tsx";
import { useIntl } from "react-intl";
import { ExpandedCourse, useCoursesLoaderData } from "../coursesLoader.ts";
import DaysRemainingMessage from "./DaysRemainingMessage.tsx";
import MaterialMetaData from "../MaterialMetaData.tsx";
import EmptyAssetCard from "../../../../../common/features/asset/EmptyAssetCard.tsx";
import useSwitchProgram from "../useSwitchProgram.tsx";
import { useLayoutData } from "../../layout/myCoursesLayoutLoader.ts";

interface DialogProps {
  onRequestClose: () => void;
}

function Course({ course }: { course: ExpandedCourse }) {
  const materialsToShow =
    course.courseMaterials.filter(
      (courseMaterial) => courseMaterial.materialStatus === "opted_in"
    ) ?? [];

  if (materialsToShow.length === 0) {
    return null;
  }

  return (
    <>
      <h2 className={styles.courseName}>{course.title}</h2>
      <ul>
        {materialsToShow.map((courseMaterial) => (
          <li className={styles.material} key={courseMaterial.id}>
            <EmptyAssetCard
              key={courseMaterial.vbid}
              type="horizontal"
              vbid={courseMaterial.vbid}
              tagName="div"
              horizontalCardImageWidth="86px"
            >
              <MaterialMetaData
                courseMaterial={courseMaterial}
                size="small"
                showTags={false}
              />
            </EmptyAssetCard>
          </li>
        ))}
      </ul>
    </>
  );
}
const EAOnlyOptOutMessage = ({ message }: { message: string | null }) => {
  if (message) {
    return <div>{message}</div>;
  }
  return null;
};

export default function ConfirmProgramOptOutDialog({
  onRequestClose,
}: DialogProps) {
  const intl = useIntl();
  const courseData = useCoursesLoaderData();
  const { config } = useLayoutData();
  const { changeProgram, isProgramChangeProcessing } =
    useSwitchProgram(onRequestClose);
  const subtitle =
    courseData.currentTerm?.institutionProgram === "equitable_access" ? (
      <EAOnlyOptOutMessage message={config.equitable_access.optOutMessage} />
    ) : (
      <DaysRemainingMessage type="decision" />
    );
  const decision = courseData.currentTerm?.programDecision;
  const currentProgramName = (decision && config[decision]?.programName) ?? "";

  return (
    <ConfirmOptOutDialog
      isProcessing={isProgramChangeProcessing}
      onRequestClose={onRequestClose}
      title={intl.formatMessage(
        {
          defaultMessage: "Opting out of {programName}",
        },
        { programName: currentProgramName }
      )}
      subtitle={subtitle}
      onConfirmOptOut={() => changeProgram("no_program")}
    >
      {courseData.courses.map((course) => (
        <Course course={course} key={course.id} />
      ))}
    </ConfirmOptOutDialog>
  );
}
